const routeNames = {
	adminLogin: "adminLogin",
	adminADLogin: "adminADLogin",
	adminGoogleLogin: "adminGoogleLogin",
	adminOrders: "adminOrders",
	adminSingleOrder: "adminSingleOrder",
	adminNewOrder: "adminNewOrder",
	adminSettings: "adminSettings",
	adminShopSettings: "adminShopSettings",
	adminTenantSettings: "adminTenantSettings",
	adminFeatureTogglePage: "adminFeatureTogglePage",
	adminOperations: "adminOperations",
	adminProducts: "adminProducts",
	adminProductOverview: "adminProductOverview",
	adminProductCreate: "adminProductCreate",
	adminIngredients: "adminIngredients",
	adminIngredientsOverview: "adminIngredientsOverview",
	adminProductsIngredients: "adminProductsIngredients",
	adminProductIngredientsOverview: "adminProductIngredientsOverview",
	adminCreateIngredientOverview: "adminCreateIngredientOverview",
	adminCreateProductIngredients: "adminCreateProductIngredients",
	adminCatalogPages: "adminCatalogPages",
	adminCatalogPagesUI: "adminCatalogPagesUI",
	adminCatalogPagesOverview: "adminCatalogPagesOverview",
	adminCatalogPagesUIOverview: "adminCatalogPagesUIOverview",
	adminDemoData: "adminDemoData",
	adminOrderStatistics: "adminOrderStatistics2",
	adminProductStatistics: "adminProductStatistics",
	adminPrototypePayments: "adminPrototypePayments",
	adminPrototypeVikingOrder: "adminPrototypeVikingOrder",
	adminDevSupport: "adminDevSupport",
	adminShopOptions: "adminShopOptions",
	adminExport: "adminExport",
	adminShopsSettings: "adminShopsSettings",
	adminTimePicker: "adminTimePicker",
	productCounterOverview: "productCounterOverview",
	productMonitoring: "productMonitoring",
	productMonitoring2: "productMonitoring2",
	productMonitoring3: "productMonitoring3",
	productMonitoring4: "productMonitoring4",
	productMonitoring5: "productMonitoring5",
	orderMonitoring: "orderMonitoring",
	adminPickupDateTimeRules: "adminPickupDateTimeRules",
	adminPriceRules: "adminPriceRules",
	adminMarketingCards: "adminMarketingCards",
	adminTargetingGroups: "adminTargetingGroups",
	adminPunchCardRules: "adminPunchCardRules",
	adminVouchers: "adminVouchers",
	adminPickupRulesSingle: "adminPickupRulesSingle",
	adminCapacityRulesPrototype: "adminCapacityPrototype",
	adminCapacityRules: "adminCapacityRules",
	adminClientRedirects: "adminClientRedirects",
	adminShopInfo: "adminShopInfo",
	adminLocalizationSettings: "adminLocalizationSettings",
	adminEnrichedProductCatalogs: "enrichedProductCatalogs",
	adminOrderGenerate: "adminOrderGenerate",
	adminSynchronizations: "adminSynchronizations",
	adminUpsellRules: "adminUpsellRules",
	termsAndConditions: "termsAndConditions",
	printOrderPreparation: "printOrderPreparation",
	printOrderPreparationDay: "printOrderPreparationDay",
	printOrderReceipt: "printOrderReceipt",
	printAllSingleOrder: "printAllSingleOrder",
	printAllOrdersReceiptForDate: "printAllOrdersReceiptForDate",
	printAllOrdersForDate: "printAllOrdersForDate",
	printAllOrdersForToday: "printAllOrdersForToday",
	shops: "shops",
	checkoutStep: "checkoutStep",
	checkoutCart: "checkoutCart",
	fullBasketCheckout: "fullBasketCheckout",
	checkoutCartAdmin: "checkoutCartAdmin",
	checkoutCartInformation: "checkoutCartInformation",
	productDetails: "productDetails",
	productCatalog: "productCatalog",
	defaultProductCatalog: "defaultProductCatalog",
	qrScanner: "qrScanner",
	preCheckout: "preCheckout",
	productDetailsConfiguration: "productDetailsConfiguration",
	productDetailsConfigurationSinglePage: "productDetailsConfigurationSinglePage",
	productDetailsConfigurationSinglePageSimpleItem: "productDetailsConfigurationSinglePageSimpleItem",
	invoices: "invoices",
	orderMessages: "orderMessages",
	Home: "Home",
	loginLandingPage: "LoginLandingPage-gt2",
	cookiesWrapper: "cookiesWrapper",
	cookiesConfiguration: "cookiesConfiguration",
	catalogPagePreview: "catalogPagePreview",
	adminOrderControlPanel: "adminOrderControlPanel",
	shopSelection: "shopSelection",
	pendingOrder: "pendingOrder",
	pendingOrderReceipt: "pendingOrderReceipt",
	payment: "payment",
	userProfile: "userProfile",
	Profile: "Profile",
	GamePage: "GamePage",
	DevSupport: "DevSupport-gt2",
	DevSupportGt3: "DevSupport-gt3",
	DevSupportDemo: "DevSupport-gtDemo",
	Map: "Map-gt2",
	checkout: "checkout",
	Payment: "Payment",
	DeliveryMethod: "deliveryMethod",
	deliveryAddress: "deliveryAddress",
	DeliveryAddressPicker: "deliveryAddressPicker",
	userData: "userData",
	obsoleteVersion: "obsoleteVersion",
	VersionUpdate: "VersionUpdate",
	contactData: "contactData",
	tableServing: "tableServing",
	UserData: "UserData",
	PickupTime: "PickupTime",
	PendingOrder: "PendingOrder",
	PendingOrderDesktop: "PendingOrderDesktop",
	UserProfile: "UserProfile",
	PaymentDesktop: "PaymentDesktop",
	SignUp: "SignUp",
	CheckEmail: "CheckEmail",
	LoginForm: "loginForm",
	SignUpForm: "signUpForm",
	SubscriptionFinished: "SubscriptionFinished",
	SubscriptionScannerCode: "SubscriptionScannerCode",
	InitializeSubscription: "InitializeSubscription",
	SetMembership: "SetMembership",
	subscriptionPlans: "subscriptionPlans",
	UserOrdersList: "UserOrdersList",
	UserOrderDetails: "UserOrderDetails",
	AcceptSubscriptionTerms: "AcceptSubscriptionTerms",
	AcceptSunsetPointsTerms: "AcceptSunsetPointsTerms",
	SubscriptionTerms: "SubscriptionTerms",
	TradingConditions: "TradingConditions",
	SubscriptionPlanPause: "SubscriptionPlanPause",
	SubscriptionPlanCancel: "SubscriptionPlanCancel",
	SubscriptionCancelFeedback: "SubscriptionCancelFeedback",
	feedback: "feedback",
	feedbackCompleted: "feedbackCompleted",
	SubscriptionPaymentFailed: "SubscriptionPaymentFailed",
	SubscriptionPaymentDone: "SubscriptionPaymentDone",
	AboutSunsetToGo: "AboutSunsetToGo",
	HomePageGtDemo: "HomePage",
	HomeWrapper: "HomeWrapper",
	SubscriptionsFraudProtection: "SubscriptionsFraudProtection",
	SwitchPaymentMethod: "SwitchPaymentMethod",
	SubscriptionInvoices: "SubscriptionInvoices",
	S3Cloud: "S3Cloud",
	ProductBadges: "ProductBadges",
	auditLogGbo: "auditLogGbo",
	globalVersionsGbo: "globalVersionsGbo",
	boothNumber: "BoothNumber",
	driveInDetailsViaQrCode: "driveInDetailsViaQrCode",
	eatInDetailsViaQrCode: "eatInDetailsViaQrCode",
	scheduledTasksManager: "scheduledTasksManager",
	statistics: "statistics",
	productAvailabilityGbo: "productAvailabilityGbo",
	productGroupsGbo: "productGroupsGbo",
	adminUsersGbo: "adminUsersGbo",
	voucherRulesGbo: "voucherRulesGbo",
	crossSellRulesGbo: "crossSellRulesGbo",
	priceRulesGbo: "priceRulesGbo",
	capacityPrototypeGbo: "capacityPrototypeGbo",
	pickupRulesGbo: "pickupRulesGbo",
	termsAndConditionsGbo: "termsAndConditionsGbo",
	shopSettingsGbo: "shopSettingsGbo",
	statisticsGbo: "statisticsGbo",
	orderControlPanelGbo: "orderControlPanelGbo",
	featureToggleGbo: "featureToggleGbo",
	tenantSettingsGbo: "tenantSettingsGbo",
	countryLanguageSelectionScreen: "countryLanguageSelectionScreen",
	nutritionalInformation: "nutritionalInformation",
	groupOrder: "groupOrder",
	notifications: "notifications",
	notificationDetails: "notificationDetails",
	friendInvite: "friendInvite",
	previousOrdersReordering: "previousOrdersReordering",
	basketPresentation: "basketPresentation",
	fullBasket: "fullBasket",
	discount: "discount",
	redirectHelper: "redirectHelper",
	notFoundPage: "notFoundPage",
	pointOverview: "pointOverview",
	subscriptionUpgrade: "subscriptionUpgrade",
	subscriptionDowngrade: "subscriptionDowngrade",
	selectSubscription: "selectSubscription",
	selectPaymentPlan: "selectPaymentPlan",
	selectSubscriptionPlan: "selectSubscriptionPlan"
};

const screenIdMap = {
	[routeNames.productCatalog]: "S1",
	[routeNames.defaultProductCatalog]: "S1",
	[routeNames.Home]: "S0",
	[routeNames.loginLandingPage]: "S0",
	[routeNames.DevSupport]: "S0",
	[routeNames.Map]: "S0",
	[routeNames.userProfile]: "S0",
	[routeNames.userData]: "S0",
	[routeNames.obsoleteVersion]: "S9",
	[routeNames.VersionUpdate]: "S11",
	[routeNames.Profile]: "S0",
	[routeNames.GamePage]: "S0",
	[routeNames.productDetails]: "S2",
	[routeNames.productDetailsConfiguration]: "S2",
	[routeNames.checkoutCart]: "S3",
	[routeNames.checkoutCartAdmin]: "S3",
	[routeNames.checkoutStep]: "S4_S8",
	[routeNames.pendingOrder]: "S5",
	[routeNames.shopSelection]: "S9",
	[routeNames.tableServing]: "S13",
	[routeNames.DeliveryMethod]: "S7",
	[routeNames.UserData]: "S4",
	[routeNames.contactData]: "S4",
	[routeNames.PickupTime]: "S6",
	[routeNames.PendingOrder]: "S10",
	[routeNames.UserProfile]: "S0c",
	[routeNames.UserData]: "S0c",
	[routeNames.SignUp]: "S14",
	[routeNames.CheckEmail]: "S15",
	[routeNames.SignUpForm]: "S16",
	[routeNames.SubscriptionFinished]: "S17",
	[routeNames.subscriptionPlans]: "S18",
	[routeNames.InitializeSubscription]: "S19",
	[routeNames.SetMembership]: "S19",
	[routeNames.AcceptSubscriptionTerms]: "S20",
	[routeNames.AcceptSunsetPointsTerms]: "S20",
	[routeNames.TradingConditions]: "S20",
	[routeNames.SubscriptionPlanPause]: "S21",
	[routeNames.SubscriptionPlanCancel]: "S21",
	[routeNames.feedback]: "S22",
	[routeNames.feedbackCompleted]: "S22",
	[routeNames.SubscriptionPaymentFailed]: "S24",
	[routeNames.SubscriptionPaymentDone]: "S24",
	[routeNames.deliveryAddress]: "S25",
	[routeNames.DeliveryAddressPicker]: "S26",
	[routeNames.AboutSunsetToGo]: "S27",
	[routeNames.HomePageGtDemo]: "S28",
	[routeNames.SubscriptionCancelFeedback]: "S21",
	[routeNames.SubscriptionInvoices]: "S21",
	[routeNames.SubscriptionScannerCode]: "S21",
	[routeNames.boothNumber]: "S29",
	[routeNames.driveInDetailsViaQrCode]: "S29",
	[routeNames.checkout]: "S30",
	[routeNames.countryLanguageSelectionScreen]: "S29",
	[routeNames.nutritionalInformation]: "S31",
	[routeNames.basketPresentation]: "S32",
	[routeNames.fullBasket]: "S33",
	[routeNames.productDetailsConfigurationSinglePage]: "S34",
	[routeNames.fullBasketCheckout]: "S35"
};

const adminPrivateRoutes = [
	routeNames.adminOrders,
	routeNames.adminOrderGenerate,
	routeNames.adminSingleOrder,
	routeNames.adminNewOrder,
	routeNames.adminSettings,
	routeNames.adminShopSettings,
	routeNames.adminTenantSettings,
	routeNames.adminFeatureTogglePage,
	routeNames.adminOperations,
	routeNames.adminProducts,
	routeNames.adminProductOverview,
	routeNames.adminProductCreate,
	routeNames.adminIngredients,
	routeNames.adminIngredientsOverview,
	routeNames.adminProductsIngredients,
	routeNames.adminProductIngredientsOverview,
	routeNames.adminCreateProductIngredients,
	routeNames.adminCreateIngredientOverview,
	routeNames.adminCatalogPages,
	routeNames.adminCatalogPagesUI,
	routeNames.adminCatalogPagesOverview,
	routeNames.adminCatalogPagesUIOverview,
	routeNames.adminDemoData,
	routeNames.adminOrderStatistics,
	routeNames.adminProductStatistics,
	routeNames.printOrderPreparation,
	routeNames.printOrderPreparationDay,
	routeNames.printOrderReceipt,
	routeNames.printAllSingleOrder,
	routeNames.printAllOrdersReceiptForDate,
	routeNames.printAllOrdersForDate,
	routeNames.printAllOrdersForToday,
	routeNames.adminPrototypeVikingOrder,
	routeNames.adminPrototypePayments,
	routeNames.adminDevSupport,
	routeNames.adminShopOptions,
	routeNames.adminExport,
	routeNames.productCounterOverview,
	routeNames.adminPickupDateTimeRules,
	routeNames.adminPriceRules,
	routeNames.adminMarketingCards,
	routeNames.adminTargetingGroups,
	routeNames.adminPunchCardRules,
	routeNames.adminVouchers,
	routeNames.adminPickupRulesSingle,
	routeNames.adminCapacityRulesPrototype,
	routeNames.adminCapacityRules,
	routeNames.adminClientRedirects,
	routeNames.adminOrderControlPanel,
	routeNames.adminShopsSettings,
	routeNames.adminTimePicker,
	routeNames.adminUpsellRules,
	routeNames.termsAndConditions,
	routeNames.productMonitoring,
	routeNames.productMonitoring2,
	routeNames.productMonitoring3,
	routeNames.productMonitoring4,
	routeNames.productMonitoring5,
	routeNames.orderMonitoring,
	routeNames.adminShopInfo,
	routeNames.adminLocalizationSettings,
	routeNames.adminEnrichedProductCatalogs,
	routeNames.adminSynchronizations,
	routeNames.SubscriptionsFraudProtection,
	routeNames.S3Cloud,
	routeNames.ProductBadges,
	routeNames.auditLogGbo,
	routeNames.globalVersionsGbo,
	routeNames.scheduledTasksManager,
	routeNames.statistics,
	routeNames.productAvailabilityGbo,
	routeNames.productGroupsGbo,
	routeNames.adminUsersGbo,
	routeNames.voucherRulesGbo,
	routeNames.crossSellRulesGbo,
	routeNames.priceRulesGbo,
	routeNames.capacityPrototypeGbo,
	routeNames.pickupRulesGbo,
	routeNames.termsAndConditionsGbo,
	routeNames.shopSettingsGbo,
	routeNames.statisticsGbo,
	routeNames.orderControlPanelGbo,
	routeNames.featureToggleGbo,
	routeNames.tenantSettingsGbo
];

const adminPublicRoutes = [
	routeNames.adminLogin,
	routeNames.adminADLogin,
	routeNames.adminGoogleLogin
];

const productionForbiddenRoutes = [
	routeNames.adminPrototypeVikingOrder,
	routeNames.adminPrototypePayments,
	routeNames.adminDevSupport
];

const hideMenuRoutes = [
	routeNames.invoices,
	routeNames.catalogPagePreview,
	routeNames.redirectHelper
];

const hideMenuRoutesGt2 = [
	routeNames.SwitchPaymentMethod,
	routeNames.Home,
	routeNames.loginLandingPage,
	routeNames.DevSupport,
	routeNames.checkoutStep,
	routeNames.checkoutCart,
	routeNames.pendingOrder,
	routeNames.pendingOrderReceipt,
	routeNames.payment,
	routeNames.shopSelection,
	routeNames.Profile,
	routeNames.userProfile,
	routeNames.GamePage,
	routeNames.Map,
	routeNames.DeliveryMethod,
	routeNames.userData,
	routeNames.obsoleteVersion,
	routeNames.tableServing,
	routeNames.CheckEmail,
	routeNames.SignUp,
	routeNames.SubscriptionFinished,
	routeNames.SubscriptionPaymentDone,
	routeNames.subscriptionPlans,
	routeNames.SubscriptionPlanPause,
	routeNames.SubscriptionPlanCancel,
	routeNames.SubscriptionCancelFeedback,
	routeNames.AcceptSubscriptionTerms,
	routeNames.AcceptSunsetPointsTerms,
	routeNames.SubscriptionScannerCode,
	routeNames.SubscriptionTerms,
	routeNames.TradingConditions,
	routeNames.feedback,
	routeNames.feedbackCompleted,
	routeNames.InitializeSubscription,
	routeNames.SubscriptionPaymentFailed,
	routeNames.deliveryAddress,
	routeNames.DeliveryAddressPicker,
	routeNames.AboutSunsetToGo,
	routeNames.SubscriptionInvoices,
	routeNames.boothNumber,
	routeNames.driveInDetailsViaQrCode,
	routeNames.countryLanguageSelectionScreen,
	routeNames.UserOrdersList,
	routeNames.UserOrderDetails,
	routeNames.nutritionalInformation,
	routeNames.redirectHelper,
	routeNames.subscriptionUpgrade,
	routeNames.fullBasketCheckout
];

const hideMenuRoutesGt3 = [
	routeNames.Home,
	routeNames.DevSupportGt3,
	routeNames.checkout,
	routeNames.Payment,
	routeNames.tableServing,
	routeNames.shopSelection,
	routeNames.DeliveryMethod,
	routeNames.contactData,
	routeNames.PickupTime,
	routeNames.PendingOrder,
	routeNames.UserProfile,
	routeNames.UserData,
	routeNames.PaymentDesktop,
	routeNames.CheckEmail,
	routeNames.SignUpForm,
	routeNames.SubscriptionFinished,
	routeNames.InitializeSubscription,
	routeNames.SetMembership,
	routeNames.TradingConditions,
	routeNames.SubscriptionPaymentFailed,
	routeNames.SubscriptionPaymentDone,
	routeNames.deliveryAddress,
	routeNames.DeliveryAddressPicker,
	routeNames.AcceptSubscriptionTerms,
	routeNames.AcceptSunsetPointsTerms,
	routeNames.SubscriptionInvoices,
	routeNames.boothNumber,
	routeNames.previousOrdersReordering,
	routeNames.basketPresentation,
	routeNames.redirectHelper,
	routeNames.fullBasket
];

const hideMenuRoutesDemo = [
	routeNames.Home,
	routeNames.checkoutCart,
	routeNames.Payment,
	routeNames.userProfile,
	routeNames.DevSupportDemo,
	routeNames.HomePageGtDemo,
	routeNames.HomeWrapper,
	routeNames.shopSelection,
	routeNames.DeliveryMethod,
	routeNames.redirectHelper
];

export default {
	routeNames,
	adminPrivateRoutes,
	adminPublicRoutes,
	productionForbiddenRoutes,
	isAdminRoute(routeName) {
		return [...adminPrivateRoutes, ...adminPublicRoutes].includes(routeName);
	},
	isHideMenuRoute(routeName, template) {
		switch (template) {
		case "defaultGlobalTemplate":
			return hideMenuRoutes.includes(routeName);
		case "gt2":
			return hideMenuRoutesGt2.includes(routeName);
		case "gt3":
			return hideMenuRoutesGt3.map(route => route.toLowerCase()).includes(routeName.toLowerCase());
		case "gtDemo":
			return hideMenuRoutesDemo.map(route => route.toLowerCase()).includes(routeName.toLowerCase());
		default:
			return false;
		}
	},
	/**
     * Returns the screen ID corresponding to a given route
     * @param routeName
     * @returns {*|string}
     */
	getScreenId(routeName) {
		const id = screenIdMap[routeName];
		return id || "";
	}
};
